﻿import {initCart, loadCartStep, loadLeaseForm} from "@/CartModule"
import {LeaseProvider} from "@/enums";

window.addEventListener("load", () => {
    initCart(true, false);
});
window.addEventListener("popstate",
    e => {
        if (e.state) {
            if (e.state.step) {
                const step = parseInt(e.state.step);
                loadCartStep(step, true);
            } else if (e.state.leaseProvider) {
                const leaseProvider = e.state.leaseProvider as LeaseProvider;
                loadLeaseForm(leaseProvider)
            }
        }
    });